export enum LabelMode {
  DEFAULT = 'default',
  INLINE = 'inline',
  NO_LABEL = 'noLabel',
}
